<template>
  <div class="transactions" :class="{'t-loading': loading}" v-loading="loading">
    <div class="transaction" :class="{'flatten': flatten}" v-for="transaction in filteredTransactions" :key="transaction.id">
      <div class="transaction-info" v-if="!loading">
        <i :class="iconClasses(transaction)" />
        <div class="info-group">
          <p>{{ transaction.name }}</p>
          <div v-if="!flatten">
            <span v-if="transaction.purchase">{{ transaction.description }}{{ transaction.station ? ' @ ' + transaction.station.name : '' }}</span>
          </div>
          <span v-if="!flatten">{{ transaction.createdAt }}</span>
        </div>
      </div>
      <div class="transaction-value" :class="colorClasses(transaction)">
        {{ actualCurrency(transaction) }}
      </div>
    </div>
    <h3 class="no-data" v-if="filteredTransactions.length === 0 && !loading">{{ noDataString }}</h3>
  </div>
</template>

<script>
export default {
  name: 'Transactions',
  props: {
    api: {
      type: String,
      required: true
    },
    limit: {
      type: Number,
      required: false
    },
    noData: {
      type: String,
      required: false
    },
    flatten: {
      type: Boolean,
      required: false
    },
    newlyAddedTransaction: {
      type: Object,
      required: false
    },
    filter: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      loading: true,
      transactionToAdd: this.newlyAddedTransaction,
      transactions: [],
      noDataString: this.noData || 'No transactions found'
    }
  },
  computed: {
    filteredTransactions () {
      return this.transactions.filter(transaction => {
        if (this.filter) {
          let hasReturn = false
          if (this.filter.range && this.filter.range.length === 2) {
            let date = new Date(transaction.createdAt)
            if (date.getTime() >= this.filter.range[0].getTime() && date.getTime() <= this.filter.range[1].getTime()) {
              hasReturn = true
            }
          } else {
            hasReturn = true
          }

          if (this.filter.purchases && transaction.purchase) {
            if (hasReturn) {
              return transaction
            }
          }

          if (this.filter.deposits && !transaction.purchase) {
            if (hasReturn) {
              return transaction
            }
          }
        } else {
          return transaction
        }
      })
    }
  },
  watch: {
    filteredTransactions (val) {
      this.$emit('change', val.length)
    },
    newlyAddedTransaction (val) {
      if (val !== null) {
        this.transactions.unshift(this.newlyAddedTransaction)
        this.$emit('count', this.transactions.length)
      }
    }
  },
  methods: {
    userCurrency (transaction) {
      return (transaction.amount / transaction.user.currency.rate) + ' ' + transaction.user.currency.name
    },
    actualCurrency (transaction) {
      return transaction.amount + ' ' + transaction.currency
    },
    iconClasses (transaction) {
      return {
        'negative': transaction.purchase,
        'el-icon-minus': transaction.purchase,
        'positive': !transaction.purchase,
        'el-icon-plus': !transaction.purchase
      }
    },
    colorClasses (transaction) {
      return {'negative': transaction.purchase}
    },
    getTransactions () {
      this.$http.get(this.api)
        .then(response => {
          if (this.limit) {
            let lim = this.limit
            if (response.data.length < this.limit) {
              this.transactions = response.data
            } else {
              this.transactions = response.data.slice(0, lim)
            }
          } else {
            this.transactions = response.data
          }
          this.$emit('count', response.data.length)
          this.loading = false
        }, _ => {

        })
    }
  },
  created () {
    this.getTransactions()
  }
}
</script>

<style lang="scss" scoped>
  .transactions {
    @include breakpoint (xs) {
      padding: 0px 0px;
    }
  }

  .t-loading {
    min-height: 156.5px;
  }

  .positive {
    color: $green;
  }

  .negative {
    color: $red;
  }

  .no-data {
    line-height: 126.5px;
    text-align: center;
    font-size: 22px;
    color: #DCDFE6;
  }

  .flatten {
    height: 50px !important;

    .transaction-info {
      .info-group {
        p {
          font-size: 14px !important;
        }
      }
    }
  }

  .transaction {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 75px;
    padding: 10px 0px;
    overflow: hidden;

    @include breakpoint (xs) {
      padding: 10px 0px;
      height: auto;
    }

    &:nth-last-child(2) {
      border-bottom: none !important;
    }

    .transaction-info {
      display: flex;
      align-items: center;

      svg, i {
        font-size: 20px;
        margin-right: 35px;

        @include breakpoint (xs) {
          display: none;
        }
      }

      .info-group {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;

        color: $text;

        p {
          margin: 0;
          font-size: 14px;
        }

        span {
          color: $text-light;
          font-size: 12px;
        }

        @include breakpoint (xs) {
          p {
            font-size: 14px;
          }

          span {
            font-size: 10px;
          }
        }

      }
    }

    .transaction-value {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      font-size: 14px;

      @include breakpoint (xs) {
        font-size: 12px;
      }

      span {
          font-size: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/transactions/Transactions.vue